import {
    Output,
    Component,
    EventEmitter,
    ElementRef,
    HostBinding,
    QueryList,
    AfterContentInit,
    ContentChildren, ViewEncapsulation, OnDestroy, HostListener, Input
} from '@angular/core';
import { VgAPI } from '../services/vg-api';
import { VgFullscreenAPI } from '../services/vg-fullscreen-api';
import { VgUtils } from '../services/vg-utils';
import { VgMedia } from '../vg-media/vg-media';
import { Subscription } from 'rxjs';
import { VgControlsHidden } from '../services/vg-controls-hidden';
import { VgSeekBarApi } from '../services/vg-seekbar-api';

@Component({
    selector: 'vg-player',
    encapsulation: ViewEncapsulation.None,
    template: `<ng-content></ng-content>`,
    styles: [`
        vg-player {
            font-family: 'iconfont';
            position: relative;
            display: flex;
            width: 100%;
            height: 100%;
            overflow: hidden;
            background-color: black;
        }

        vg-player.fullscreen {
            position: fixed;
            left: 0;
            top: 0;
        }

        vg-player.native-fullscreen.controls-hidden {
            cursor: none;
        }
    ` ],
    providers: [VgAPI, VgFullscreenAPI, VgControlsHidden, VgSeekBarApi]
})

export class VgPlayer implements AfterContentInit, OnDestroy {
    elem: HTMLElement;

    @HostBinding('class.fullscreen') isFullscreen: boolean = false;
    @HostBinding('class.native-fullscreen') isNativeFullscreen: boolean = false;
    @HostBinding('class.controls-hidden') areControlsHidden: boolean = false;
    @HostBinding('class.fake-fullscreen') isFakeFullScreen: boolean = false;

    @HostBinding('style.z-index') zIndex: string;

    @Output()
    onPlayerReady: EventEmitter<any> = new EventEmitter();

    // @Output()
    // onMediaReady: EventEmitter<any> = new EventEmitter();

    @ContentChildren(VgMedia)
    medias: QueryList<VgMedia>;

    subscriptions: Subscription[] = [];

    // @Input()
    // danmuFacade;
    constructor(
        ref: ElementRef,
        public api: VgAPI,
        public fsAPI: VgFullscreenAPI,
        private controlsHidden: VgControlsHidden,

    ) {
        this.elem = ref.nativeElement;
        this.api.registerElement(this.elem);
    }

    ngAfterContentInit() {
        this.medias.toArray().forEach((media) => {
            this.api.registerMedia(media);
        });

        this.fsAPI.init(this.elem, this.medias);

        this.subscriptions.push(this.fsAPI.onChangeFullscreen.subscribe(this.onChangeFullscreen.bind(this)));
        this.subscriptions.push(this.controlsHidden.isHidden.subscribe(this.onHideControls.bind(this)));

        this.api.onPlayerReady(this.fsAPI);
        this.api.assignHidden(this.controlsHidden);
        this.onPlayerReady.next(this.api);
    }

    onChangeFullscreen(fsState: boolean) {
        // if (this.danmuFacade) {
        //     this.danmuFacade.setFullScreen(fsState);
        // }
        if (VgFullscreenAPI.fakeFullScreen) {
            this.isFakeFullScreen = fsState;
            this.isNativeFullscreen = false;
        }
        else {
            if (!this.fsAPI.nativeFullscreen) {
                this.isFullscreen = fsState;
                this.zIndex = fsState ? VgUtils.getZIndex().toString() : 'auto';
            } else {
                this.isNativeFullscreen = fsState;
            }
        }
    }

    onHideControls(hidden: boolean) {
        this.areControlsHidden = hidden;
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }


    // clicked=0;

    // doubleCliked=0;

    // doubleClickTimer={

    //     left: {
    //         timer: null,
    //         isSingleClick:false,
    //         clicked:0,
    //         shouldprevent:false
    //     }
    // }
    // @HostListener("click")
    // clickTest()
    // {
    //     ++this.clicked;
    //    console.log(this.clicked);


    //         var config = this.doubleClickTimer["left"];

    //         if(!config.shouldprevent)
    //         {
    //             config.isSingleClick = true;
    //             ++config.clicked;
    //             //console.log(config);

    //             if (config.timer != null) {

    //                 VgUtils.clearTimeout(config.timer);
    //                 config.isSingleClick = false;
    //                 config.timer = null;
    //                 this.fsAPI.toggleFullscreen();
    //                 console.log("double clicked");

    //             }
    //             else {
    //                 config.timer = VgUtils.setTimeout(() => {
    //                     if (config.isSingleClick) {
    //                         console.log("clicked");
    //                     }
    //                     config.timer = null;
    //                 }, 200)
    //             }
    //         }


    // }
    // @HostListener("dblclick")
    // dblclickTest()
    // {
    //     ++this.doubleCliked;
    //     this.fsAPI.toggleFullscreen();
    //    console.log("dbl",this.doubleCliked);
    // }
}
